module.exports = __webpack_public_path__ + "img/undo.b3669f74.svg";